/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FailureResponse,
  StrukturOrganisasiPublicChartResponse,
  StrukturOrganisasiPublicStrukturResponse,
  SuccessEnvelope
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicStrukturOrganisasiChartUrl = () => {




  return `/public/struktur-organisasi/chart`
}

export const getPublicStrukturOrganisasiChart = async ( options?: RequestInit): Promise<SuccessEnvelope & StrukturOrganisasiPublicChartResponse> => {

  return publicFetch<SuccessEnvelope & StrukturOrganisasiPublicChartResponse>(getGetPublicStrukturOrganisasiChartUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicStrukturOrganisasiChartQueryKey = () => {
    return [
    `/public/struktur-organisasi/chart`
    ] as const;
    }


export const getGetPublicStrukturOrganisasiChartQueryOptions = <TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicStrukturOrganisasiChartQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>> = ({ signal }) => getPublicStrukturOrganisasiChart({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicStrukturOrganisasiChartQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>>
export type GetPublicStrukturOrganisasiChartQueryError = FailureResponse


export function useGetPublicStrukturOrganisasiChart<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>,
          TError,
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStrukturOrganisasiChart<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>,
          TError,
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStrukturOrganisasiChart<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicStrukturOrganisasiChart<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiChart>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicStrukturOrganisasiChartQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicStrukturOrganisasiPeriodeUrl = () => {




  return `/public/struktur-organisasi/periode`
}

export const getPublicStrukturOrganisasiPeriode = async ( options?: RequestInit): Promise<SuccessEnvelope & StrukturOrganisasiPublicStrukturResponse> => {

  return publicFetch<SuccessEnvelope & StrukturOrganisasiPublicStrukturResponse>(getGetPublicStrukturOrganisasiPeriodeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicStrukturOrganisasiPeriodeQueryKey = () => {
    return [
    `/public/struktur-organisasi/periode`
    ] as const;
    }


export const getGetPublicStrukturOrganisasiPeriodeQueryOptions = <TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicStrukturOrganisasiPeriodeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>> = ({ signal }) => getPublicStrukturOrganisasiPeriode({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicStrukturOrganisasiPeriodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>>
export type GetPublicStrukturOrganisasiPeriodeQueryError = FailureResponse


export function useGetPublicStrukturOrganisasiPeriode<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>,
          TError,
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStrukturOrganisasiPeriode<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>,
          TError,
          Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStrukturOrganisasiPeriode<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicStrukturOrganisasiPeriode<TData = Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStrukturOrganisasiPeriode>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicStrukturOrganisasiPeriodeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






